import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId, ISelectItem } from '~/types/models'
import type {
  IOpportunityMasterService,
  IOpportunityMSService,
} from '~/types/opportunity/models'
import type { ICompany } from '~/types/company/models'
import { Location } from '~/cynqueModules/dataObjects/Location'

const apiEntityPath = '/api/opportunitymasterservices'

export async function getCompanyFromOpportunityMasterService(id: TEntityId) {
  const callingMn = getCompanyFromOpportunityMasterService.name
  const apiPath = `${apiEntityPath}/${id}/company`
  return httpGet<ICompany>({ callingMn, apiPath })
}

export async function createOpportunityMasterService(
  entity: IOpportunityMasterService
) {
  const callingMn = createOpportunityMasterService.name
  const apiPath = apiEntityPath
  return httpPost<IOpportunityMasterService>({
    callingMn,
    apiPath,
    entity,
  })
}

/**
 * @param onlyWithAssignableMSServices See `getSuppliersFromOpportunity`
 *   (WXTG/cynque-api-server#1816).
 */
export async function getSuppliersFromOpportunityMasterService(
  id: TEntityId,
  onlyWithAssignableMSServices: boolean = false
) {
  const callingMn = getSuppliersFromOpportunityMasterService.name
  const apiPath =
    `${apiEntityPath}/${id}/suppliers` +
    (onlyWithAssignableMSServices ? '?onlywithassignablemsservices=true' : '')
  return httpGet<IOpportunityMasterService>({ callingMn, apiPath })
}

export async function updateOpportunityMasterService(
  entityData: Partial<IOpportunityMasterService>,
  id: TEntityId
) {
  const callingMn = updateOpportunityMasterService.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIOpportunityMasterService = Partial<IOpportunityMasterService>
  return httpPatchMerge<TPartialIOpportunityMasterService>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOpportunityMasterService(
  entityData: IOpportunityMasterService
) {
  const callingMn = deleteOpportunityMasterService.name
  const apiPath = apiEntityPath
  return httpDelete<IOpportunityMasterService>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function getPotentialLocationSelectItemsForServicesOfOpportunityMasterService(
  id: TEntityId
) {
  const callingMn =
    getPotentialLocationSelectItemsForServicesOfOpportunityMasterService.name
  const apiPath = `${apiEntityPath}/${id}/potentiallocations`
  return httpGet<ISelectItem[]>({
    callingMn,
    apiPath,
  })
}
